<template>
  <div>
    <div class="top">
      <!-- <div style="display: flex; align-items: center">
        <img src="@/assets/imageJie/logo_1.png" class="logo" />\
        <span class="logo-name">LMD&nbsp;Top-up&nbsp;Center</span>
      </div> -->
      <div class="name" @click="handleShow()">
        <img src="@/assets/imagePai/yonghu.png" />
        <span style="margin-left: 15px;">{{ userInfo?.userName || "用户名" }}</span>
        <div class="ddh" v-if="showFlag == true">
          <span @click.stop="handleRecord()" key="1122">歷史交易</span>
          <span id="logout" @click="handleOut()">登出</span>
        </div>
      </div>
    </div>
    <div class="zan"></div>

    <div class="nr">
      <router-view />
    </div>

    <div class="footer">
      <div class="emali">客服E-mail:lmdhaikyucs@gmail.com</div>
      <div class="zc">
        <div><a href="https://haikyu.lmdgame.tw/contract/">用戶協議</a></div>
        <div style="margin-left: 20px">
          <a href="https://haikyu.lmdgame.tw/privacy/">隱私政策</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  removeAccessToken,
  removeRefreshToken,
  removeUserInfo,
  getUserInfo,
} from "@/util/auth";

export default {
  name: "layout",
  data() {
    return {
      showFlag: false,
      userInfo:JSON.parse(getUserInfo())
    };
  },
  methods: {
    handleShow() {
      this.showFlag = !this.showFlag;
    },
    handleOut() {
      this.showFlag = false;
      removeAccessToken();
      removeRefreshToken();
      removeUserInfo();
      location.reload();
    },
    handleRecord() {
      this.showFlag = !this.showFlag;
      console.log(this.showFlag);
      this.$router.push({
        path: "/record",
      });
    },
  },

  mounted() {
    this.$bus.$on("bus-event", (data) => {
     this.userInfo = JSON.parse(getUserInfo())
    });
  },
};
</script>

<style lang="less" scoped>
.nr {
  width: 100%;
  height: 980px;
  background: url(../assets/imagePai/bg_2.png) center no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nr:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.zan {
  width: 100%;
  height: 100px;
}
</style>